export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5124.5deb9630.jpg";